import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const TerrainIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M0 19L6.54545 9.66667L11.4545 16.6667H19.6364L14.1818 8.90833L11.4545 12.7583L10.0909 10.8333L14.1818 5L24 19H0ZM4.36364 16.6667H8.72727L6.54545 13.5458L4.36364 16.6667Z" />
  </Icon>
)
